import type { FC } from "react"

interface Props {
  className?: string
}

const Mute: FC<Props> = ({ className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 18.3333C9 19.2616 8.63125 20.1518 7.97487 20.8082C7.3185 21.4646 6.42826 21.8333 5.5 21.8333C4.57174 21.8333 3.6815 21.4646 3.02513 20.8082C2.36875 20.1518 2 19.2616 2 18.3333C2 17.4051 2.36875 16.5148 3.02513 15.8585C3.6815 15.2021 4.57174 14.8333 5.5 14.8333C6.42826 14.8333 7.3185 15.2021 7.97487 15.8585C8.63125 16.5148 9 17.4051 9 18.3333ZM9 18.3333V9M15.324 15.3583C14.8751 15.6368 14.4951 16.0132 14.2124 16.4594C13.9297 16.9055 13.7517 17.4099 13.6916 17.9347C13.6316 18.4594 13.6911 18.991 13.8657 19.4895C14.0403 19.988 14.3254 20.4405 14.6998 20.8131C15.0741 21.1858 15.5279 21.4688 16.0272 21.6411C16.5266 21.8134 17.0584 21.8705 17.5829 21.808C18.1073 21.7456 18.6109 21.5652 19.0558 21.2805C19.5006 20.9957 19.8753 20.614 20.1516 20.1638M9 4.33333V3.16667H20.6667V16M12.5 7.83333H20.6667M2 2L23 23"
        stroke="#002800"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Mute
